import { lazy } from "react"

export const Clients = lazy(() => import("views/clients/Clients"))
export const AddClient = lazy(() => import("views/clients/AddClient"))
export const ClientDetails = lazy(() => import("views/clients/clientDetails/ClientDetails"))
export const PayementDetails = lazy(() => import("views/clients/clientDetails/tabs/PayementDetails"))
export const Invoices = lazy(() => import("views/clients/clientDetails/tabs/Invoices"))
export const LinkSubscriptionFormModal = lazy(() => import("views/clients/components/LinkSubscriptionFormModal"))